export default [
    {
      path: '/quickwins/tarification',
      name: 'quickwins-tarification',
      component: () => import('@/views/quickwins/tarificateur/TarificateurParent'),
    },
  ]